import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "user-agency-page" })
export default class UserAgencyComponent extends Vue {}
